import { React, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import DailyReflection from '../components/profile/DailyReflection';
import EmailReminder from '../components/profile/EmailReminder';
import Settings from '../components/profile/Settings';
import '../styles/Profile.css';

export default function Profile({ setProfileOption, profileOption }) {
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const search = new URLSearchParams(location.search);
        const tab = search.get('tab');
        if (tab && tab !== profileOption) {
            setProfileOption(tab); // Set profileOption based on the URL tab
        }
    }, [location.search, setProfileOption, profileOption]);

    // Debugging: Log the full location object
    useEffect(() => {
        const history = location.state?.history || [];
        if (history.includes('/onboard')) {
            const timeoutId = setTimeout(() => navigate('/'), 1000);
            return () => clearTimeout(timeoutId);
        }
    }, [location.state?.history, navigate]);

    const showPage = () => {
        if (profileOption === 'dailyreflection') {
            return <DailyReflection />;
        } else if (profileOption === 'emailreminder') {
            return <EmailReminder />;
        } else if (profileOption === 'settings') {
            return <Settings />;
        }
    };

    return (
        <div className='profile-main-container d-flex'>
            <Sidebar
                profileOption={profileOption}
                setProfileOption={setProfileOption}
            />
            {showPage()}
        </div>
    );
}
